import PhishingTest from "./PhishingTest";

export default PhishingTest;
